module.exports = __webpack_public_path__ + "img/Dantam Bridal 02.4b4b9ecd.jpg";